import { render, staticRenderFns } from "./TaxonomyCloneModal.vue?vue&type=template&id=2afab712&scoped=true&"
import script from "./TaxonomyCloneModal.vue?vue&type=script&lang=js&"
export * from "./TaxonomyCloneModal.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyCloneModal.vue?vue&type=style&index=0&id=2afab712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afab712",
  null
  
)

export default component.exports